/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Box, Icon, IconButton, Paper, Tooltip, useMediaQuery, Input } from "@mui/material";
import { FC, useCallback, useEffect, useMemo, useState } from "react";
import { InputText } from "src/framework/components/forms/inputs/InputText";
import { InputPhone } from "src/framework/components/forms/inputs/InputPhone";
import { InputUploadImage } from "src/framework/components/forms/inputs/InputUploadImage";
import { LocalStorage } from "src/framework/commons/LocalStorage";
import api, { apiNoLoading } from "src/framework/providers/api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { BottomBar } from "src/framework/components/commons/BottomBar";
import { ModalSolicitacoes } from "./container/ModalSolicitacoes";
import { ModalCriarSoliciatacao } from "./container/ModalCriarSolicitacao";
import { TrocarDistribuidor } from "src/providers/cadastros/TrocaDistribuidor";
import { UserProposta } from "src/providers/cadastros/TrocaDistribuidor/types";
import { ContaUploads } from "src/components/contas/contas/ContaUploads";
import defaultListStore from "src/framework/store/DefaultListStore";
import { UserDocument } from "src/components/contas/contas/types";
import { PermissionUtil } from "src/framework/commons/PermissionUtil";
import { useObservable } from "src/framework/store/storeUtil";
import { mensagemWhatsAppProposta$, resolveProtocolUrl } from "src/store/global.store";
import { SelectCodigoServico } from "./container/SelectCodigoServico";
import { authUser$ } from "src/framework/components/navigations/MenuUser";
import { setServicoCodeModalStatus } from "src/store/vendas/projetos/actions";
import { ServicoCodeModal } from "src/components/projetos/containers/ServicoCodeModal";
import theme from "src/theme/light";
import { notifierStore } from "src/framework/store/NotifierStore";
import { LoginStore } from "src/framework/store/LoginStore";
import { confirmationDialog } from "src/framework/store/ConfirmationDialogStore";
import { Upload } from "src/components/componentes/types";
import { ContaProvider } from "src/providers/cadastros/ContaProvider";
import { FlatButton } from "src/framework/components/buttons/FlatButton";
import { FullWidthButton } from "src/framework/components/buttons/FullWidthButton";

const solicitacoes = new TrocarDistribuidor();
const contasProvider = new ContaProvider();
const EMAIL_PROPOSTA = "email_proposta"

interface ConfigFormProperties {
    onCancel?: Function;
    callEdit?: Function;
};

const ConfiguracaoRevendaForm: FC<ConfigFormProperties> = () => {
    const userInfo = LocalStorage.get("solar.userExtraInfo", true);
    const [progressImg, setProgressImg] = useState<number | undefined>(undefined);
    const [imgState, setImgState] = useState<string>("");
    const ContaUpload: ContaUploads = new ContaUploads(api, apiNoLoading);
    const [openDialog, setOpenDialog] = useState<boolean>(false);
    const [openDialogSolicitacao, setopenDialogSolicitacao] = useState<boolean>(false);
    const [userProposta, setUserProposta] = useState<UserProposta | null>(null);
    const [errorState, setErrorState] = useState<string[]>([]);
    const permissoes:string[] = useObservable(LoginStore.permissoes) || [];
    const authUser = useObservable(authUser$);
    const [novaSolicitacaoData, setNovaSolicitacaoData] = useState<{ status: boolean; mensagem: string }>({ status: false, mensagem: "" });
    const [contaCodigoServico, setContaCodigoServico] = useState('');

    const isMobile = useMediaQuery(theme.breakpoints.down('md'))

    const [documentos, setDocumentos] = useState<UserDocument>({
        imagem: null,
    });

    useEffect(()=>{
        setContaCodigoServico(authUser?.codigo_servico_conta || "");
    },[authUser?.codigo_servico_conta])

    const verificarPossibilidadeNovaSolicitacao = useCallback(() => {
        if (!userInfo?.revenda_cnpj_cpf) return;
        solicitacoes.verificarPossibilidadeNovaSolicitacao(userInfo?.revenda_cnpj_cpf).then(response => {
            setNovaSolicitacaoData({
                status: response?.solicitacao_liberada || false,
                mensagem: response?.mensagens?.[0] || "",
            })
        }) 
    }, [userInfo?.revenda_cnpj_cpf])

    useEffect(()=>{
       verificarPossibilidadeNovaSolicitacao(); 
    },[verificarPossibilidadeNovaSolicitacao])

    const callEdit = async () => {
        if(userProposta) {
            const data = {
                mensagem_whatsapp: PermissionUtil.can(PermissionUtil.PERMISSION_ATUALIZAR_MENSAGEM_WHATSAPP, permissoes) ? (userProposta?.mensagem_whatsapp || null) : undefined,
                whatsapp_proposta: userProposta?.whatsapp_proposta,
                email_proposta: userProposta?.email_proposta,
                conta_uploads: documentos.imagem && PermissionUtil.can(PermissionUtil.PERMISSION_PROJETO_CONTAS_PERMITE_TROCA_LOGO, permissoes) ? [{
                    tipo:  documentos.imagem?.tipo,
                    url: documentos.imagem?.url,
                    "@remove": documentos.imagem?.["@remove"],
                }] : undefined,
            }
            contasProvider.putUsuarioConta(userProposta.id, data).then((response) => {
                mensagemWhatsAppProposta$.next(data.mensagem_whatsapp || '');            
            }).catch((error) => {
                notifierStore.setNotifier({
                    title: "Aviso!!!",
                    content: error.message,
                    timeOut: 3000,
                    onClose: () => {
                        notifierStore.setOpen(false);
                    }
                })
                notifierStore.setOpen(true);
            })
        }


        if (contaCodigoServico && podeEditarCodigoServico) {
            const patchCodigoServicoResult = await contasProvider.patchCodigoServico({ codigo_servico: contaCodigoServico })
            if (patchCodigoServicoResult) {
                const authUserLocal = { ...authUser, codigo_servico_conta: contaCodigoServico };
                authUser$.next(authUserLocal);
            }
        }

        setErrorState([]);
    }

    const handleClose = () => {
        setOpenDialog(false);
        setopenDialogSolicitacao(false);
    };
    
    const handleOpenDialog = (): void => {
        setOpenDialog(true);
        return;
    };

    const handleOpenDialogSolicitacao = (): void => {
        setopenDialogSolicitacao(true);
        return;
    };

    useEffect(() => {
        if (userInfo?.isRevenda){
            contasProvider.getUsuarioConta(userInfo?.revenda_id).then(response => {
                setUserProposta(response)
            }) 
        }else if(userInfo?.isDistribuidor){
            contasProvider.getUsuarioConta(userInfo?.distribuidor_id).then(response => {
                setUserProposta(response)
            }) 
        }else{
            contasProvider.getUsuarioConta(userInfo?.userId).then(response => {
                setUserProposta(response)
            })  
        }
    }, [])

    useEffect(() => {
        if (userProposta?.conta_uploads) {
            const idxImage = userProposta?.conta_uploads.findIndex((up: any) => up.tipo === 'logo');
            if (idxImage > -1) {
                const _upload = LocalStorage.get("solar.uploadInfo", true);
                setImgState(resolveProtocolUrl(`//${_upload?.data?.url}${defaultListStore.uploadUrl}${userProposta?.conta_uploads[idxImage].url}?r=${Math.floor(Math.random() * 100) + 1}`))
            }
        }
    }, [userProposta]);

    const podeEditarCodigoServico = useMemo(()=>{
        return PermissionUtil.can(PermissionUtil.PERMISSION_CODIGO_SERVICO_MANUTENCAO, permissoes);
    },[permissoes])

    const checkValidation = useCallback(()=>{
        if (podeEditarCodigoServico && !contaCodigoServico) {
            setErrorState(old => [...old, "codigo_servico"]);
            return false;
        }
        
        return true;
    },[podeEditarCodigoServico, contaCodigoServico])

    return (
        <>
            <Paper elevation={0} style={{ padding: "0 7px ", marginTop: "7px" }}>
                {PermissionUtil.can(PermissionUtil.PERMISSION_PROJETO_DISTRIBUIDOR_LISTAGEM, permissoes) && (
                    <div className="container">
                        <span className="row X--start" style={{ textAlign: "left", paddingLeft: "5px"}}>
                            <h3>Distribuidor de Energia</h3>    
                        </span>
                        <div className="row">
                            <div className="X12 M6" >
                                <InputText 
                                    label={"Razão Social:"}
                                    fullWidth={true}
                                    value={userInfo?.distribuidor_nome}
                                    name={"razão social"}
                                    disabled
                                />
                            </div>
                            <div className="X12 M6">
                                <InputText
                                    label={"CNPJ"}
                                    fullWidth={true}
                                    value={userInfo?.distribuidor_cnpj_cpf}
                                    name={"cnpj"}
                                    disabled
                                />
                            </div>
                        </div>
                        {PermissionUtil.can(PermissionUtil.PERMISSION_PROJETO_DISTRIBUIDOR_MANUTENCAO, permissoes) && <div className="row X--end"  style={{ marginRight: 0 }}>
                            <Tooltip title={"Histórico de solicitações"} placement="top">
                                <IconButton
                                    size="small"
                                    style={{marginRight: "10px"}}
                                    onClick={() => handleOpenDialogSolicitacao()}
                                >
                                    <Icon>history</Icon>
                                </IconButton>
                            </Tooltip>
                            <Tooltip title={!novaSolicitacaoData.status ? (novaSolicitacaoData.mensagem || "") : ''}>
                                <span>
                                    <FlatButton
                                        text="Alterar Distribuidor"
                                        size="small"
                                        variant="contained"
                                        color="primary"
                                        disabled={!novaSolicitacaoData.status}
                                        onClick={() => handleOpenDialog()}
                                    />
                                </span>
                            </Tooltip>
                        </div>}
                    </div>
                )}
                { PermissionUtil.can(PermissionUtil.PERMISSION_PROJETO_PROPOSTA_COMERCIAL, permissoes) && (
                    <>
                        <span className="row X--start" style={{ textAlign: "left", paddingLeft: "10px"}}>
                            <h3>Proposta Comercial</h3>    
                        </span>
                        <span className="row X--start" style={{ textAlign: "left", paddingLeft: "10px"}}>
                            <h4>Logo</h4>    
                        </span>
                        <div className="container">
                            <div className="row">
                                <div className="X12 M3">
                                    <InputUploadImage
                                        progress={progressImg}
                                        id={Number(userInfo?.isRevenda ? userInfo?.revenda_id : (userInfo?.isDistribuidor ? userInfo?.distribuidor_id : userInfo?.userId))}
                                        url={imgState}
                                        downloadName={`logo-${userInfo?.isRevenda ? userInfo?.revenda_id : (userInfo?.isDistribuidor ? userInfo?.distribuidor_id : userInfo?.userId)}`}
                                        disableRemover={!PermissionUtil.can(PermissionUtil.PERMISSION_PROJETO_CONTAS_PERMITE_TROCA_LOGO, permissoes)}
                                        disableSelecionar={!PermissionUtil.can(PermissionUtil.PERMISSION_PROJETO_CONTAS_PERMITE_TROCA_LOGO, permissoes)}
                                        onHandleUpload={(id: number, file: File) => {
                                        ContaUpload.uploadImage({
                                                userId: userInfo?.isRevenda ? userInfo?.revenda_id : (userInfo?.isDistribuidor ? userInfo?.distribuidor_id : userInfo?.userId),
                                                file: file, 
                                                tipo: "logo", 
                                                onProgress: (_progress) => { setProgressImg(_progress) } 
                                                }).then((data) => {
                                                const state: any = { ...userProposta }
                                                const idxUpload = userProposta?.conta_uploads?.findIndex((up: Upload) => up.tipo === "logo");
                                                if (idxUpload) {
                                                    state.conta_uploads = data?.url;
                                                }
                                                documentos.imagem = data;
                                                setDocumentos(documentos);
                                            }).finally(() => {
                                            })
                                        }}
                                        onHandleRemove={() => {
                                        confirmationDialog.setup({
                                            title: "Aviso!!!",
                                            content: `Deseja remover a logo da proposta?`,
                                            onClose: () => {
                                            confirmationDialog.close();
                                            },
                                            onNegation: () => {
                                            },
                                            onConfirmation: () => {
                                            documentos.imagem = {
                                                "@remove": true,
                                                tipo: "logo",
                                                url: ""
                                            }
                                            setDocumentos(documentos);
                                            confirmationDialog.close();
                                            }
                                        })
                                        confirmationDialog.open()
                                        }}
                                        key={`logo-image-${userInfo?.isRevenda ? userInfo?.revenda_id : (userInfo?.isDistribuidor ? userInfo?.distribuidor_id : userInfo?.userId)}`}
                                        style={{
                                        marginBottom: "8px"
                                        }}
                                    />
                                </div>
                            </div>
                        </div>

                        {PermissionUtil.can(PermissionUtil.PERMISSION_ATUALIZAR_MENSAGEM_WHATSAPP, permissoes) && (
                            <>
                                <span className="row X--start" style={{ textAlign: "left", paddingLeft: "10px"}}>
                                    <h4>Mensagem WhatsApp</h4>    
                                </span>
                                <div className="container">
                                    <div className="row">
                                        <div className="X12 M6">
                                            <InputText
                                                disabled={!PermissionUtil.can(PermissionUtil.PERMISSION_ATUALIZAR_MENSAGEM_WHATSAPP, permissoes)}
                                                id="mensagem-whatsapp-conta"
                                                InputLabelProps={{ shrink: true }}
                                                value={userProposta?.mensagem_whatsapp || ''}
                                                size="medium"
                                                name={"mensagem_whatsapp"}
                                                multiline
                                                fullWidth={true}
                                                maxRows={6}
                                                minRows={6}
                                                maxLength={1000}
                                                onChange={(e: any) => {
                                                    if (!userProposta) return;
                                                    setUserProposta({ ...userProposta, mensagem_whatsapp: String(e.target.value || '') })
                                                }}
                                                helperText={(
                                                    <>
                                                        <span>Esta será a mensagem padrão enviada pelo WhatsApp.</span><br/>
                                                        <span>Quando você incluir {"{link_proposta}"} no texto, o sistema irá substituir automaticamente pelo link da proposta.</span><br/>
                                                        <span>Se quiser, você poderá editar a mensagem no momento em que o WhatsApp for aberto para envio.</span>
                                                    </>
                                                )}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}


                        <span className="row X--start" style={{ textAlign: "left", paddingLeft: "10px"}}>
                            <h3>WhatsApp</h3>    
                        </span> 
                        <InputPhone
                            label="Celular"
                            value={userProposta?.whatsapp_proposta}
                            onChangeValue={(newValue) => {
                            if (userProposta) {
                                const { value } = newValue
                                setUserProposta({ ...userProposta, whatsapp_proposta: String(value) })
                            }
                            }}
                        />
                    </>
                )}
                { PermissionUtil.can(PermissionUtil.PERMISSION_PROJETO_EMAIL_LISTAGEM, permissoes) && (
                    <>
                        <span className="row X--start" style={{ textAlign: "left", paddingLeft: "10px"}}>
                            <h3>E-mail para notificações</h3>
                            <Tooltip title={"O e-mail será utilizado para o envio das informações sobre os projetos"} placement="top">
                                <IconButton size="small">
                                    <FontAwesomeIcon icon={faInfoCircle} />
                                </IconButton>
                            </Tooltip>
                        </span> 
                        <InputText
                            label="E-mail"
                            fullWidth
                            defaultValue={""}
                            error={errorState.includes(EMAIL_PROPOSTA)}
                            value={userProposta?.email_proposta}
                            disabled={!PermissionUtil.can(PermissionUtil.PERMISSION_PROJETO_EMAIL_MANUTENCAO, permissoes)}
                            onChange={(event: any) => {
                                if (userProposta) {
                                    setUserProposta({ ...userProposta, email_proposta: String(event?.target?.value) })
                                }
                            }}
                            type="text"
                        />
                    </>
                )}
                { podeEditarCodigoServico && (
                    <>
                        <span className="row X--start" style={{ textAlign: "left", paddingLeft: "10px"}}>
                            <h3>Código de serviço</h3>
                            <IconButton size="small" onClick={() => setServicoCodeModalStatus(true)}>
                                <FontAwesomeIcon icon={faInfoCircle} />
                            </IconButton>
                        </span> 
                        <Box width={isMobile ? '100%' : "200px"}>
                            <SelectCodigoServico
                                codigoServico={contaCodigoServico}
                                onChangeCodigoServico={(value) => setContaCodigoServico(value || "")}
                                error={!!errorState.includes("codigo_servico")}
                                helperText={errorState.includes("codigo_servico") ? "Campo obrigatório" : ""}
                            />
                        </Box>
                    </>
                )}
                {(PermissionUtil.can(PermissionUtil.PERMISSION_PROJETO_EMAIL_MANUTENCAO, permissoes) ||
                    podeEditarCodigoServico ||
                    PermissionUtil.can(PermissionUtil.PERMISSION_PROJETO_PROPOSTA_COMERCIAL, permissoes) ||
                    PermissionUtil.can(PermissionUtil.PERMISSION_PROJETO_CONTAS_PERMITE_TROCA_LOGO, permissoes)) && (
                    <>
                        {isMobile ? (
                            <Button style={{ marginTop: "8px", width: "100%" }} onClick={async () => callEdit()} color="primary" variant="contained">
                                Salvar
                            </Button>
                        ) : (
                            <BottomBar>
                                <FullWidthButton
                                    color="primary"
                                    variant="contained"
                                    disableElevation
                                    text="Salvar"
                                    onClick={async () => {
                                        const isValid = checkValidation();
                                        if (!isValid) return;
                                        await callEdit();
                                    }}
                                />
                            </BottomBar>
                        )}
                    </>
                )}
            </Paper>
            { openDialog && (
                <ModalCriarSoliciatacao 
                    openDialog={openDialog}
                    handleClose={handleClose}
                    onConfirm={verificarPossibilidadeNovaSolicitacao}
                />
            )}
            
            { openDialogSolicitacao && (
                <ModalSolicitacoes
                    openDialogSolicitacao={openDialogSolicitacao} 
                    handleClose={handleClose}
                />
            )}

            <ServicoCodeModal />
        </>
    )
}

export { ConfiguracaoRevendaForm }
